import { getFunctions, httpsCallable } from "firebase/functions";

type AssignAssetIdRequest = { id: string };
type AssignAssetIdResponse = { assetId: number };

const REGION = "europe-west1";

export async function ensureAssetIdForItem(id: string): Promise<number> {
  const fns = getFunctions(undefined, REGION); // default app
  const call = httpsCallable<AssignAssetIdRequest, AssignAssetIdResponse>(fns, "assignAssetId");
  const res = await call({ id });
  return res.data.assetId;
}
